import React from 'react';
import { LoaderFunctionArgs } from 'react-router-dom';
import { loadProvider } from '@/common/api';
import ProviderShowPage from '@/portal/routes/providers/$providerId/Page.tsx';

export async function loader({ params }: LoaderFunctionArgs) {
  if (!params.providerId) {
    throw new Response('Missing provider ID', { status: 400 });
  }

  return loadProvider(params.providerId);
}

const ShowRoute: React.FC = () => {
  return <ProviderShowPage />;
};

export default ShowRoute;
